// src/utils/testCustomer.js
//
// The browser's ONE test-customer check, shared by every report, board and count that leaves test accounts out, so
// none of them can disagree about what counts as real business (docs/features/test_customer_sweep_FEATURE.md §2.2).
//
// The rule and its code are the server's: functions-shared/utils/testCustomers.js (the customer's name ends with one
// of the configured test names, whole words, ignoring case). The names are the live list from Settings → Test
// Customers: testCustomerMarkersStore listens to it and writes it here, so a computed that calls this re-runs when
// the list changes. This file stays free of Firebase on purpose: board and report helpers import it, and so do their
// hermetic tests (until the store has a list, it is the default ['Tester']).
//
// Not the test-walk fence: what an AI test session may touch is decided server-side by last name exactly "Tester".

import { ref } from 'vue'
import {
  DEFAULT_TEST_MARKERS,
  isTestCustomer as matchesTestNames,
} from '../../functions-shared/utils/testCustomers'

export const testCustomerMarkers = ref([...DEFAULT_TEST_MARKERS])

/** Only testCustomerMarkersStore calls this, from its listener. */
export function setTestCustomerMarkers(markers) {
  testCustomerMarkers.value = markers
}

export function isTestCustomer(customer) {
  return matchesTestNames(customer, testCustomerMarkers.value)
}

export default isTestCustomer
